import React, {useEffect, useState} from "react";
import "./Geofence.scss"
import toaster from "toasted-notes";
import {useHistory} from "react-router-dom";
import {HomeHeader} from "../../Components";

var polyLines = [];
var currentPolyLine = null;
var drManager = null;
let  currentGeo = {};
let map = {}



function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function GeofenceOne() {

    const history = useHistory()



    useEffect(()=>{
        _initMap()
    },[])




    const _initMap =  ()=> {
        let _map = new window.google.maps.Map(document.getElementById('map'),{
            center: {lat:35.6892,lng:51.3890},
            gestureHandling: "greedy",
            zoom: 10,
            zoomControl: false,
            zoomControlOptions: {
                position: window.google.maps.ControlPosition.RIGHT_CENTER
            },
            scrollwheel: true,
            streetViewControl: false,
            mapTypeControl: false,
            mapTypeId: 'roadmap',
        });

        window.google.maps.event.addListener(drawingManager, 'polygoncomplete', (polyline)=> {
            cleanGeo()
             currentPolyLine= polyline;
            drawingManager.setDrawingMode(null);
            console.log("s",polyline)
        });



        map = _map
        drawingManager.setMap(_map);
        getGeo()
    }

    const drawingManager = new window.google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: false,
        drawingControlOptions: {
            position: window.google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [
                // window.google.maps.drawing.OverlayType.MARKER,
                // window.google.maps.drawing.OverlayType.CIRCLE,
                window.google.maps.drawing.OverlayType.POLYGON,
                // window.google.maps.drawing.OverlayType.POLYLINE,
                // window.google.maps.drawing.OverlayType.RECTANGLE,
            ],
        },
        polygonOptions: {
            editable: true,
        },
        circleOptions: {
            fillColor: "#ffff00",
            fillOpacity: 1,
            strokeWeight: 5,
            clickable: false,
            editable: true,
            zIndex: 1,
        },
    });

    //------------------------------------------- geo crud ----------------------- //

    const getGeo  = async () =>{
        let localGeo = localStorage.getItem('geo');
        let zoom = localStorage.getItem('map_zoom');
        console.log("zooom : ",zoom)
        if(localGeo){
            let parsedGeo = JSON.parse(localGeo)
            const bermudaTriangle = new window.google.maps.Polygon({
                paths: parsedGeo,
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                editable: true,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
            });
            console.log("Map geo",localGeo)
            console.log("Map geo",map)
            console.log("Map geo",bermudaTriangle)
            bermudaTriangle.setMap(map);
            map.setCenter(parsedGeo[0]);
            if(zoom){
                map.setZoom(parseInt(zoom));
            }else {
                map.setZoom(10);
            }
            currentPolyLine = bermudaTriangle;
        }
    }

    const setGeo  = async () =>{
        console.log(currentPolyLine.getPath())
        let points = null;
        if(currentPolyLine.getPath().Mb){
             points = currentPolyLine.getPath().Mb.map(item=>{
                return {lat:item.lat(),lng:item.lng()}
            });
        }
        if(currentPolyLine.getPath().Lb){
            points = currentPolyLine.getPath().Lb.map(item=>{
                return {lat:item.lat(),lng:item.lng()}
            });
        }

       console.log(points)
       localStorage.removeItem('geo')
       localStorage.setItem('geo',JSON.stringify(points))
       localStorage.setItem('map_zoom',map.getZoom())
       toaster.notify(({ onClose }) => (<Success   message={"محدوده با موفقیت ثبت شد"}/>),{duration: 700});
    }

    const cleanGeo  = async () =>{
        if(currentPolyLine){
            currentPolyLine.setMap(null)
            currentPolyLine = null
        }
    }






    const sendPoly = ()=>{
        let points = polyLines[0].getPath().Mb.map(item=>{
            return {lat:item.lat(),lng:item.lng()}
        });
        console.log(points)
        var htmlStr = "";
        for (var i = 0; i < polyLines.length; i++) {
            htmlStr += "polyline #" + i + " # vertices=" + polyLines[i].getPath().getLength() + " length=" + window.google.maps.geometry.spherical.computeLength(polyLines[i].getPath()).toFixed(2) + " km<br>";
            for (var j = 0; j < +polyLines[i].getPath().getLength(); j++) {
                htmlStr += "&nbsp;&nbsp;" + polyLines[i].getPath().getAt(j).toUrlValue(6) + "<br>";
            }
        }
        document.getElementById('output').innerHTML = htmlStr;
    }

    const sendCurrentPoly = ()=>{
        var htmlStr = "";

            htmlStr += "polyline #" + 1 + " # vertices=" + currentPolyLine.getPath().getLength() + " length=" + window.google.maps.geometry.spherical.computeLength(currentPolyLine.getPath()).toFixed(2) + " km<br>";
            for (var j = 0; j < +currentPolyLine.getPath().getLength(); j++) {
                htmlStr += "&nbsp;&nbsp;" + currentPolyLine.getPath().getAt(j).toUrlValue(6) + "<br>";
            }

        document.getElementById('output').innerHTML = htmlStr;
    }

    const showPoly = ()=>{



        const triangleCoords = [
            {lat: 35.90640194451566,lng: 51.4047928466797 },
            { lat: 35.79620439497458, lng: 51.25922399902345},
            { lat: 35.76723824083224,lng: 51.5036697998047 }
        ];
        // Construct the polygon.
        const bermudaTriangle = new window.google.maps.Polygon({
            paths: triangleCoords,
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            editable: true,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
        });
        bermudaTriangle.setMap(map);
        currentPolyLine = bermudaTriangle;

    }

    const clearMap = () =>{
        polyLines.forEach(poly=>{
            poly.setMap(null)
        })
    }

    const removeGeo = ()=>{
        if(currentPolyLine){
            currentPolyLine.setMap(null)
            currentPolyLine = null
        }
        localStorage.removeItem('geo')
    }

    return(
        <div>
            <HomeHeader />
            <div>
                <span
                    className="geo-btns-add"
                    onClick={()=>{setGeo()}}>
                ثبت
            </span>
                <span
                    className="geo-btns-draw"
                    onClick={()=>{
                        drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
                    }}>
                رسم
            </span>
                <span
                    className="geo-btns-edit"
                    onClick={()=>{
                        drawingManager.setDrawingMode(null);
                    }}>
                ویرایش
            </span>
                <span
                    className="geo-btns-remove"
                    onClick={()=>{
                        removeGeo()
                    }}>
                حذف
                </span>


                <div id="output"></div>
                <div id="map" style={{marginTop:50,width:'100%',height:'100vh'}}></div>
            </div>
        </div>
    )
}

export {GeofenceOne}
